import PropTypes from 'prop-types';
import React from 'react';
import DataService from '../../lib/DataService';
import Utils from "./ClockUtils";
import { Modal, message, Avatar, Card, Spin } from "antd";
import { hashHistory, Link } from 'react-router';

const { Meta } = Card;

export default class ClockIndexPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired, // this is passed from the Rails div
  };

  /**
   * @param props - Comes from your rails div.
   */
  constructor(props) {
    super(props);
    let day = new Date();
    let currentDay = new Date(day.getFullYear(), day.getMonth(), day.getDate()).getTime();

    this.state = {
      taskId: props.params.taskId,
      currentDay,
      student_count: 0,
      students: [],
      absentStudents: [],
      visible: false,
      loading: false
    };
  }

  componentDidMount() {
    this.setState({
      loading: true
    })
    DataService.getOneTaskDetail(this.state.taskId).then((res) => {
      this.setState({
        task: res,
        currentDay: res.is_completed ? new Date(res.expire_at) : this.state.currentDay,
        student_count: res.student_ids ? res.student_ids.length : 0,
        loading: false
      })
    }).catch((error) => {
      console.log(error);
      this.setState({
        loading: false
      })
    });

    DataService.getRankInfo(this.state.taskId).then((res) => {
      this.setState({
        students: res.rank_info.filter(student => student.attendance_count > 0),
        absentStudents: res.rank_info.filter(student => student.attendance_count <= 0)
      })
    }).catch((error) => {
      console.log(error);
      
    });

  }

  goClockContent(item) {
    hashHistory.push(`clock-in/tasks/${this.state.taskId}/clock-content?year=${item.year}&month=${item.month}&day=${item.day}`);
  }

  viewFile(e, file) {
    e.stopPropagation();
    this.setState({
      visible: true,
      file
    })
  }

  onCancelModal() {
    this.setState({
      visible: false,
    })
  }

  _imageViewModal() {
    let file = this.state.file;
    return (
      <div className="image-view-modal">
        <div className="image-view-modal-mask" onClick={() => this.onCancelModal()}></div>
        <div className="photos-wrapper">
          <div className="face-recognition-photos-view">
            <span className="photo-view-span">
              {file.file_type == 'photo' ? <img src={file.remote_url} className="photo-card-img" /> : <video controls src={file.remote_url} className="photo-card-img" ></video>}
            </span>
          </div>
          <div className="image-view-modal-cancel" onClick={() => this.onCancelModal()} ></div>
        </div>
      </div>
    )
  }

  // 打卡内容
  _taskItemView(item) {
    return (
      <div className="card-item task-detail">
        <div className="item-header">
          <div>{item.title}</div>
        </div>
        <pre className="item-content">{item.description}</pre>
        <div className="img-container">
          {item.upload_files.map(file =>
            <div className="img-box" key={file.id} onClick={(e) => this.viewFile(e, file)}>
              <img className="img" src={Utils.getSmallMedia(file.remote_url, file.file_type)}>
              </img>
            </div>
          )}
        </div>
        <div className="item-info-list">
          <div className="info-detail">
            <div className="info-title">打卡频率</div>
            <div className="info-label">{Utils.toolsFrequency(item.frequency_info)}</div>
          </div>
          <div className="info-detail">
            <div className="info-title">参与人员</div>
            <div className="info-label">{item.student_ids_info && item.student_ids_info.length > 0 ? '学生' + item.student_ids_info.length + '人' : '全班'}</div>
          </div>
          <div className="info-detail">
            <div className="info-title">是否允许补卡</div>
            <div className="info-label">{item.can_supplement ? '允许' : '不允许'}</div>
          </div>
        </div >
      </div >
    )
  }

  // 打卡天数详情
  _circleView(task) {
    let { currentDay, student_count } = this.state;
    return (
      <div className="card-item task-detail">
        <div className="circle-list">
          {task.attendance_info.map((item, index) => <div className={`circle-detail${Utils.toolsDayTime(item) <= currentDay ? '' : ' blank'}`} onClick={() => this.goClockContent(item)} key={index}>
            <div className="circle">
              {Utils.toolsDayTime(item) <= currentDay ? item.attendance_count + '/' + student_count : ''}
            </div>
            <div className="circle-label">{Utils.toolsDay(item)}</div>
          </div>)}
        </div>
      </div>
    )
  }

  // 排行榜
  _rankList(students) {
    return (
      <div className="card-item task-detail">
        {students.map((item, index) => <div className="detail-box" key={`student-${item.student.id}`}>
          <div>
            {item.student.avatar_url ? <img className="avatar" src={item.student.avatar_url.match(/\?image/) ? item.student.avatar_url : item.student.avatar_url + '?imageView2/1/w/150'} /> : <div className="avatar default-avatar"></div>}
            <div className="text">
              <div className="text-bg">{item.student.full_name}</div>
              <div className="text-sm">已打卡{item.attendance_count}天</div>
            </div>
          </div>
        </div>)}
      </div>
    )
  }

  render() {
    let { task, students, absentStudents, visible, loading} = this.state;
    return (
      <Spin tip="加载中..." spinning={loading}>
        <div className="clock-index-page">
          <div className="card-list">
            {task ? this._taskItemView(task) : ''}
            {task ? <div className="card-label">{task.is_completed ? '已结束' : '已进行' + task.current_day_index + '/' + task.days_count + '天'}</div> : ''}
            {task ? this._circleView(task) : ''}
            <div className="card-label">排行榜</div>
            {students.length > 0 ? this._rankList(students) : ''}
            {absentStudents.length > 0 ? this._rankList(absentStudents) : ''}
            {visible ? this._imageViewModal() : ''}
          </div>
        </div >
      </Spin>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/clock/ClockDetailPage.jsx